import { getWaitingList, getOtpNumber } from '@/service/api'
import otp from 'speakeasy'

export function playSound (vm, item) {
  vm.isPlaying = true
  setTimeout(function () {
    vm.isPlaying = false
    if (vm.video) {
      vm.video.volume = 0.3
    }
  }, 7300)
  if (vm.video) {
    vm.video.volume = 0.1
  }
  if (!item) {
    vm.isPlaying = false
    if (vm.video) {
      vm.video.volume = 0.3
    }
    return
  }
  vm.enterItem = item

  let filename = '/bell.mp3'
  const audio = new Audio(filename)
  audio.onended = function () {
    const one = ['일', '이', '삼', '사', '오', '육', '칠', '팔', '구']
    const ten = ['십', '백']
    let numberText = []
    // TODO: 임시로 작업해서 추후 시간있을 때 수정해야합니다.
    if (item.waitSequenceStatic > 0) {
      const numberList = item.waitSequenceStatic.toString().split('')
      numberList.forEach((v, i) => {
        if (v === 0) {
          return
        }
        if (numberList.length > 2) {
          // 100 자리
          if (i === 0) {
            if (v > 1) {
              numberText.push(one[v - 1])
            }
            numberText.push(ten[1])
          } else if (i === 1) {
            if (v > 1) {
              numberText.push(one[v - 1])
            }
            if (v >= 1) {
              numberText.push(ten[0])
            }
          } else {
            if (v >= 1) {
              numberText.push(one[v - 1])
            }
          }
        } else if (numberList.length > 1) {
          // 10 자리
          if (i === 0) {
            // 10자리
            if (v > 1) {
              numberText.push(one[v - 1])
            }
            if (v >= 1) {
              numberText.push(ten[0])
            }
          } else {
            // 1자리
            if (v >= 1) {
              numberText.push(one[v - 1])
            }
          }
        } else {
          // 1의 자리
          numberText.push(one[v - 1])
        }
      })
    }

    let name = item.guest ? (item.guest.phone === item.guest.name ? '고객' : item.guest.name) : '고객'
    let msg = new SpeechSynthesisUtterance(`${numberText.length > 0 ? '대기번호 ' + numberText.join('') + '번 ' : ''}${name}님 지금 입장해주세요~`)

    // 각 환경별/매장별 다른 메시지를 호출할 수 있도록 합니다. (TB-662가 출발점)
    const env = process.env.VUE_APP_ENV
    const restaurantIdx = item.restaurantIdx
    let isCustomMessage = false
    switch (env) {
      case 'development': // 개발 환경
        console.log('#development')
        switch (restaurantIdx) {
          case 50505: // 밀랑
            // 0000고객님 2층으로 올라오세요.
            if (item.guest && item.guest.phone) {
              const phoneNumberText = item.guest.phone.slice(-4).split('').map(numberChar => {
                if (parseInt(numberChar) === 0) return '영'
                return one[parseInt(numberChar) - 1]
              })
              msg = new SpeechSynthesisUtterance(`${phoneNumberText.join(' ')} 고객님 2층으로 올라오세요~`)
            } else if (numberText.length > 0) {
              msg = new SpeechSynthesisUtterance(`대기번호 ${numberText.join('')} 번 고객님 2층으로 올라오세요~`)
            }
            isCustomMessage = true
            break
          case 51725: // 포케(FE)
            // 휴대폰 뒤 4자리만 호출합니다.
            if (item.guest && item.guest.phone) {
              const phoneNumberText = item.guest.phone.slice(-4).split('').map(numberChar => {
                if (parseInt(numberChar) === 0) return '영'
                return one[parseInt(numberChar) - 1]
              })
              msg = new SpeechSynthesisUtterance(`${phoneNumberText.join(',')} 고객님 지금 입장해주세요~`)
            }
            isCustomMessage = true
            break
        }
        break
      case 'staging': // 스테이징 환경
        switch (restaurantIdx) {
          case 51677: // [QA] 7_전체 서비스+대기주문
            // 0000고객님 2층으로 올라오세요.
            // if (item.guest && item.guest.phone) {
            //   const phoneNumberText = item.guest.phone.slice(-4).split('').map(numberChar => {
            //     if (parseInt(numberChar) === 0) return '영'
            //     return one[parseInt(numberChar) - 1]
            //   })
            //   msg = new SpeechSynthesisUtterance(`${phoneNumberText.join(' ')} 고객님 2층으로 올라오세요~`)
            // } else if (numberText.length > 0) {
            //   msg = new SpeechSynthesisUtterance(`대기번호 ${numberText.join('')} 번 고객님 2층으로 올라오세요~`)
            // }
            // isCustomMessage = true
            // break

            // 휴대폰 뒤 4자리만 호출합니다.
            if (item.guest && item.guest.phone) {
              const phoneNumberText = item.guest.phone.slice(-4).split('').map(numberChar => {
                if (parseInt(numberChar) === 0) return '영'
                return one[parseInt(numberChar) - 1]
              })
              msg = new SpeechSynthesisUtterance(`${phoneNumberText.join(',')} 고객님 지금 입장해주세요~`)
            }
            isCustomMessage = true
            break
        }
        break
      case 'production': // 운영 환경
        switch (restaurantIdx) {
          case 8819: // [QA] 세분화 테스트1
          case 9641: // TB-764: 속초항아리물회
            // 0000고객님 2층으로 올라오세요.
            if (item.guest && item.guest.phone) {
              const phoneNumberText = item.guest.phone.slice(-4).split('').map(numberChar => {
                if (parseInt(numberChar) === 0) return '영'
                return one[parseInt(numberChar) - 1]
              })
              msg = new SpeechSynthesisUtterance(`${phoneNumberText.join(' ')} 고객님 2층으로 올라오세요~`)
            } else if (numberText.length > 0) {
              msg = new SpeechSynthesisUtterance(`대기번호 ${numberText.join('')} 번 고객님 2층으로 올라오세요~`)
            }
            isCustomMessage = true
            break
          case 8899: // 로마경양식 매장
            // 휴대폰 뒤 4자리만 호출합니다.
            if (item.guest && item.guest.phone) {
              const phoneNumberText = item.guest.phone.slice(-4).split('').map(numberChar => {
                if (parseInt(numberChar) === 0) return '영'
                return one[parseInt(numberChar) - 1]
              })
              msg = new SpeechSynthesisUtterance(`${phoneNumberText.join(',')} 고객님 지금 입장해주세요~`)
            }
            isCustomMessage = true
            break
        }
        break
    }

    msg.rate = 1
    msg.pitch = 1.2

    if (isCustomMessage) {
      msg.rate = 0.8
    }

    window.speechSynthesis.speak(msg)
  }
  audio.play().then().catch((err) => {
    console.error(err)
  })
}

export async function updateBackgroundImage (vm, waitingDisplayMediaUrls = []) {
  try {
    // 기존 default 이미지 제거
    vm.adList = []

    // waitingDisplayMediaUrls가 있으면 해당 데이터 사용, 없으면 기본 이미지 사용
    const mediaUrls = waitingDisplayMediaUrls && waitingDisplayMediaUrls.length > 0
      ? waitingDisplayMediaUrls
      : [
          'http://image.tabling.co.kr/production/wd/wd-default-01.jpg',
          'http://image.tabling.co.kr/production/wd/wd-default-02.jpg',
          'http://image.tabling.co.kr/production/wd/wd-default-03.jpg'
        ]

    mediaUrls.forEach((url, index) => {
      const isVideo = url.endsWith('.mp4') || url.endsWith('.webm') || url.endsWith('.mov')
      const mediaInfo = {
        type: isVideo ? 'video' : 'image',
        url: url,
        verticalUrl: url,
        idx: index
      }
      vm.adList.push(mediaInfo)
    })
  } catch (error) {
    console.error('[updateBackgroundImage] adList error ----- ', error)
  }
}

// function displayCheck (vm) {
//   const displayType = vm.mode === 'horizontal' ? 'WDH27' : 'WDV27'
//   if (vm.info) {
//     if (vm.info.kioskType !== displayType) {
//       sendDisplayType(vm.restaurantIdx, {
//         kioskType: displayType
//       })
//     }
//   } else {
//     sendDisplayType(vm.restaurantIdx, {
//       kioskType: displayType
//     })
//   }
// }

export async function loadData (vm) {
  const { data } = await getWaitingList(vm.restaurantIdx)
  console.log('[loadData] getWaitingList 응답 데이터:', data)
  console.log('[loadData] data.restaurant:', data.restaurant)
  console.log('[loadData] waitingDisplayMediaUrls:', data.restaurant.waitingDisplayMediaUrls)
  vm.list = data.list
  vm.info = data.restaurant
  // displayCheck(vm)

  // waitingDisplayMediaUrls 처리 (없을 경우 기본 이미지 사용)
  updateBackgroundImage(vm, data.restaurant.waitingDisplayMediaUrls)

  vm.list.forEach(v => {
    if (vm.enterItem) {
      if (v.waitSequenceStatic !== vm.enterItem.waitSequenceStatic) {
        // vm.enterItem = null
      }
    }
  })
  vm.notificationList = vm.list.filter(v => {
    return v.notificationCount >= 1
  }).sort((a, b) => {
    if (a.notificationSendTime > b.notificationSendTime) {
      return 1
    }
    if (a.notificationSendTime < b.notificationSendTime) {
      return -1
    }
    return 0
  })

  if (!vm.isFirst) {
    return
  }
  vm.isFirst = false

  vm.notificationList.forEach(v => {
    vm.playList.push(v)
  })
}

export async function renewalOtpNumber (vm) {
  // otp번호 생성
  const exce = (idx) => {
    const secret = `Tabling!!_${idx}`
    const now = vm.$moment()
    const token = otp.totp({ secret, time: now.unix(), step: 3600, algorithm: 'sha256' })
    return {
      token,
      remain: vm.$moment().startOf('hour').add(1, 'hour').diff(now, 'seconds')
    }
  }
  let refeatSec = 1000
  try {
    const localOtp = exce(vm.restaurantIdx)
    vm.otpNumber = localOtp.token
    refeatSec = (localOtp.remain === 0) ? 1000 : ((localOtp.remain * 1000) + 1000)
  } catch {
    const { data } = await getOtpNumber(vm.restaurantIdx)
    vm.otpNumber = data.token
    refeatSec = (data.remain === 0) ? 1000 : ((data.remain * 1000) + 1000)
  } finally {
    const localOtp = exce(vm.restaurantIdx)
    vm.otpNumber = localOtp.token
    refeatSec = (localOtp.remain === 0) ? 1000 : ((localOtp.remain * 1000) + 1000)
  }
  setTimeout(() => {
    renewalOtpNumber()
  }, refeatSec)
}
